import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { GlobalContext } from "../../../context/GlobalContext";
import { TranslateContext } from "../../../context/TranslateContext";

const StripeComp = ({ plan, paying, setPaying }) => {
  const { hitAxios } = React.useContext(GlobalContext);
  const { lang } = React.useContext(TranslateContext);

  const isLoading = paying === "stripe";

  async function handleStripe() {
    setPaying("stripe");
    const res = await hitAxios({
      path: "/api/payment/stripe/create-session",
      admin: false,
      post: true,
      obj: { plan_id: plan.id },
    });
    if (res.data.success) {
      window.location.href = res.data.url;
    } else {
      setPaying("");
    }
  }

  return (
    <Button
      fullWidth
      variant="outlined"
      size="large"
      disabled={!!paying}
      onClick={handleStripe}
      startIcon={
        isLoading ? (
          <CircularProgress size={18} color="inherit" />
        ) : (
          <span style={{ fontSize: "1.1rem" }}>💳</span>
        )
      }
      sx={{
        justifyContent: "flex-start",
        borderRadius: 2,
        fontWeight: 600,
        textTransform: "none",
        fontSize: "0.95rem",
        py: 1.2,
      }}
    >
      {isLoading
        ? lang?.redirecting || "Redirecting..."
        : lang?.payWith_stripe || "Pay with Stripe"}
    </Button>
  );
};

export default StripeComp;
